import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { getValueUpto2DecimalPlaces } from "../../RaiseInvoice/helper";

// function to calculate discounted amount without including convenience fees and gst
export const calculateDiscountedAmount = (consultation_fees, discount = 0) => {
  let discountAmount = consultation_fees - consultation_fees * (discount / 100);
  return getValueUpto2DecimalPlaces(discountAmount);
};

// calling api to update cache
export const callGetDoctorResourceAPI = (clinic_id) => {
  afterLoginApiAxios({
    method: "get",
    url: `/clinic/v1/clinics/${clinic_id}/doctor_resource_procedures`,
    headers: {
      "Cache-Control": "max-age=0",
      authorization: localStorage.getItem("id_token"),
    },
  })
    .then((response) => {
      if (response?.data?.statusCode == 200) {
        console.log("res", response);
      }
    })
    .catch((error) => {
      console.log("error", error);
    });
};
